<template>
    <v-card outlined class="login-screen">
        <v-card-text>
            <div class="login-logo">
                <img src="/images/logo/denzapine-logo-large.png" />
            </div>
            <div class="login-title">
                <h1>{{ t('login::title.forgotten_password') }}</h1>
            </div>
            <div v-show="globalErrors.length">
                <v-alert v-for="(error, index) in globalErrors" :key="index" type="error">{{ error }} </v-alert>
            </div>
            <v-form
                ref="form"
                v-model="isFormValid"
                :rules="rules"
                autocomplete="off"
                lazy-validation
                @submit.prevent="postForm"
            >
                <v-text-field
                    v-model="item.email"
                    :error-messages="errorMessages.email"
                    :label="t('login::from.label.email')"
                    :placeholder="t('login::from.placeholder.email')"
                    :rules="rules.email"
                    rounded
                    outlined
                    class="medium"
                    @keyup.enter="postForm"
                ></v-text-field>
                <div class="d-flex flex-wrap justify-content-between align-items-center mt-10">
                    <v-btn :loading="loading" class="mb-7" rounded block large color="primary" @click="postForm"
                        >{{ t('login::button.reset.confirm') }}
                    </v-btn>

                    <v-btn text rounded block large color="primary" @click.prevent="changeToLoginForm"
                        >{{ t('login::button.reset.cancel') }}
                    </v-btn>
                </div>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
let formSubmitMixin = require(process.env.MIX_APP_ROOT +
    '/bgo/bgo-components/resources/js/mixins/FormSubmit.js').default;

export default {
    name: 'RecoveryLinkForm',
    mixins: [formSubmitMixin],
    data() {
        return {
            loading: false,
            isFormValid: true,
            item: {
                email: null,
            },
            globalErrors: [],
            errorMessages: {
                email: [],
            },
            isSent: false,
        };
    },
    computed: {
        rules() {
            return {
                email: [(v) => !!v || t('default::validation.field.required')],
            };
        },
    },
    methods: {
        postForm() {
            if (this.isSent) {
                return;
            }
            this.isSent = true;

            this.submit(route('api.v1.auth.reset-password'), this.item, 'post', () => {
                this.$emit('success', true);
                this.isSent = false;
            });

            this.isSent = false;
        },
        changeToLoginForm() {
            this.$emit('cancel', true);
        },
    },
};
</script>

<style scoped></style>
